/**
 * Mini bar component for displaying percentage values.
 *
 * Used for CPU, memory, and other utilization metrics.
 *
 * Implementation plan reference: D2.16
 */

interface MiniBarProps {
  value: number;
  max?: number;
  label?: string;
  variant?: 'default' | 'success' | 'warning' | 'error';
  suffix?: string; // Optional suffix to show after percentage (e.g., "/ 1 vCPU")
}

export function MiniBar({ value, max = 100, label, variant = 'default', suffix }: MiniBarProps): JSX.Element {
  const percentage = Math.min((value / max) * 100, 100);

  return (
    <div className="mini-bar">
      {label !== undefined && <span className="mini-bar-label">{label}</span>}
      <div className="mini-bar-track">
        <div
          className={`mini-bar-fill mini-bar-${variant}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="mini-bar-value">
        {value}%{suffix !== undefined && <span className="mini-bar-suffix">{suffix}</span>}
      </span>
    </div>
  );
}
